import {
    Dic
} from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function () {
    return {
        //   add: '新增',
        //   edit: '修改',
        view: '查看',
        page: true,
        selection: false,
        index: true,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '140px',
        menuAlign: 'center',
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 400,
        dialogWidth: '700px',
        emptyText: i18n.t('personAccess.title.noData'),
        menu: false,
        column: [{
                label: '风机名称',
                prop: 'coldStorageNumberName',
                search: true,
                span: 12,
                formslot: true,

            },
            {
                label: '冷库名称',
                prop: 'coldStorageName',
                span: 12
            },
            {
                label: '状态',
                prop: 'faultStatus',
                overHidden: true,
                span: 12
            },


            // {
            //     label: '故障代码',
            //     prop: 'code',
            //     overHidden: true,
            //     span: 12
            // },
            // {
            //     label: '故障名称',
            //     prop: 'deviceName',

            //     span: 12
            // },
            {
                label: '故障时间',
                prop: 'faultTime',
                span: 12,
                formslot: true
            },
            {
                label: '故障时间',
                prop: 'time',
                span: 12,
                hide: true,
                search: true,
                searchSlot: true
            },
            // {
            //     label: '故障开始时间',
            //     prop: 'startTime',
            //     span: 12,
            //     formslot: true
            // }, {
            //     label: '故障结束时间',
            //     prop: 'endTime',
            //     overHidden: true,
            //     formslot: true,
            //     span: 12
            // },
            // {
            //     label: '故障判定条件',
            //     prop: 'mask',
            //     formslot: true,


            //     span: 12
            // },
            // {
            //     label: '故障等级',
            //     prop: 'level',
            //     span: 12
            // },
        ]
    }
}
export default tableOption